import { EAiStreamerStatus } from '@/views/CopyStake/CopyStakeAiStreamer/types';
import { IStatusMeta } from './types';

export const GROUP_THRESHOLD = 4;
export const CLUSTER_GAP_MIN = 0;
export const INTERVAL_HEIGHT = 64;
export const COLOR_STREAMER_FALLBACK = '#B0BEC5';
export const COLOR_DETAIL_FALLBACK = '#607D8B';

export const DEFAULT_COLORS: string[] = [
  '#E53935', // red
  '#FB8C00', // orange
  '#7B1FA2', // purple
  '#43A047', // green
  '#1E88E5', // blue
  '#00897B', // teal
  '#C62828', // dark red
  '#6D4C41', // brown
  '#5E35B1', // deep purple
  '#00ACC1', // cyan
  '#F4511E', // deep orange
  '#3949AB', // indigo
  '#D81B60', // pink
  '#558B2F', // light green
  '#0277BD', // light blue
  '#8E24AA', // medium purple
  '#EF6C00', // dark orange
  '#2E7D32', // dark green
  '#AD1457', // dark pink
  '#00838F' // dark cyan
];

export const STATUS_META: Record<EAiStreamerStatus, IStatusMeta> = {
  [EAiStreamerStatus.LIVE]: { label: 'Live', color: '#e53935' },
  [EAiStreamerStatus.STARTING]: { label: 'Starting', color: '#fb8c00' },
  [EAiStreamerStatus.SCHEDULED]: { label: 'Scheduled', color: '#1e88e5' },
  [EAiStreamerStatus.OFFLINE]: { label: 'Offline', color: '#9e9e9e' }
};
